@let activeLanguage = (selectedLanguage$ | async) ?? currentLanguage;

<div class="language-menu" [class.is-open]="isOpen">
  <button type="button" class="language-toggle" (click)="toggleMenu($event)">
    <span class="code">{{ activeLanguage | uppercase }}</span>
    <span class="arrow" [class.open]="isOpen">▾</span>
  </button>

  @if (isOpen) {
    <ul class="language-dropdown">
      @for (option of options; track option) {
        <li>
          <button
            type="button"
            [class.active]="option === activeLanguage"
            (click)="selectLanguage(option, $event)"
          >
            {{ labelKey(option) | translate }}
          </button>
        </li>
      }
    </ul>
  }
</div>
